export default __webpack_public_path__ + "static/plans-974dafe6c35e75171bcaeb3aee8d175f.svg";